module.exports = __webpack_public_path__ + "static/media/quote_icon.9d2fc79f.svg";